import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const DEFAULT_LANG = "pl";

type Resources = {
  pl: Record<string, string>;
  en: Record<string, string>;
};

const parseCsv = (csv: string): Resources => {
  const lines = csv.trim().split("\n");
  const [, ...rows] = lines;
  const resources: Resources = {
    pl: {},
    en: {},
  };
  rows.forEach((row) => {
    const [key, pl, en] = row.split(";");
    if (key) {
      resources.pl[key.trim()] = pl?.trim() || "";
      resources.en[key.trim()] = en?.trim() || "";
    }
  });
  return resources;
};

export const initI18n = async () => {
  const lang = localStorage.getItem("lang") || DEFAULT_LANG;
  const csv = await fetch("/locales/translations.csv").then(r => r.text());
  const resources = parseCsv(csv);
  await i18n.use(initReactI18next).init({
    resources: {
      pl: { translation: resources.pl },
      en: { translation: resources.en },
    },
    lng: lang,
    fallbackLng: DEFAULT_LANG,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });
};

export default i18n;